module.exports = __webpack_public_path__ + "img/icons BFr_20.4814edca.svg";